import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import env from '@tencent/vft-common/env';
import atom from '@tencent/vft-atom';
export function isKidAppExisted() {
  return _isKidAppExisted.apply(this, arguments);
}

function _isKidAppExisted() {
  _isKidAppExisted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(env.isApp && !env.isKidApp)) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return atom.invoke('isInstalled', {
              pkgName: 'com.tencent.qqlivekid',
              pkgUrl: 'qqlivekid://',
              appName: '小企鹅乐园'
            });

          case 3:
            res = _context.sent;
            return _context.abrupt("return", res === null || res === void 0 ? void 0 : res.installed);

          case 5:
            return _context.abrupt("return", true);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _isKidAppExisted.apply(this, arguments);
}

export default {
  isKidAppExisted: isKidAppExisted
};